require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./almost-indian-foodie.json") })
        }
      }, "path---almost-indian-foodie");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---almost-indian-foodie!./.cache/json/almost-indian-foodie.json
// module id = 705
// module chunks = 231608221292675